import React from 'react';
import Icon from '../../../components/AppIcon';

const DealCard = ({ deal, onEdit, isDragging }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(value);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getStageColor = (stage) => {
    const colors = {
      'Lead': 'bg-blue-100 dark:bg-blue-900/30',
      'Qualified': 'bg-purple-100 dark:bg-purple-900/30',
      'Proposal': 'bg-pink-100 dark:bg-pink-900/30',
      'Negotiation': 'bg-yellow-100 dark:bg-yellow-900/30',
      'Closed Won': 'bg-green-100 dark:bg-green-900/30',
      'Closed Lost': 'bg-red-100 dark:bg-red-900/30'
    };
    return colors?.[stage] || 'bg-gray-100 dark:bg-gray-800';
  };

  return (
    <div
      onClick={() => onEdit(deal)}
      className={`${getStageColor(deal?.stage)} rounded-xl p-4 md:p-5 cursor-pointer transition-all duration-250 hover:shadow-elevation-2 ${
        isDragging ? 'opacity-50 scale-95' : 'opacity-100 scale-100'
      }`}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e?.key === 'Enter' || e?.key === ' ') {
          onEdit(deal);
        }
      }}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <h3 className="text-base md:text-lg font-semibold text-foreground line-clamp-2 flex-1">
          {deal?.clientName}
        </h3>
        <Icon name="GripVertical" size={18} className="text-muted-foreground flex-shrink-0 mt-1" />
      </div>
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <Icon name="DollarSign" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="text-sm md:text-base font-semibold text-foreground data-text">
            {formatCurrency(deal?.dealValue)}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <Icon name="Calendar" size={16} className="text-muted-foreground flex-shrink-0" />
          <span className="text-xs md:text-sm text-muted-foreground">
            {formatDate(deal?.expectedCloseDate)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DealCard;